<template>
  <div class="tipsContianer fb-pay-tips">
    <i class="closeTipsBtn" v-on:click="close"></i>
    <p class="tips-content">請前往儲值頁面</p>
    <footer class="tips-footer">
      <button class="skipPayBtn" v-on:click="pay">
        {{ canPay ? "儲值" : "正在前往……" }}
      </button>
    </footer>
  </div>
</template>

<script>
import { fbSdkPay } from "../utile/fb";
import { POPUP_STYLE } from "./TipPopUpIframe";
import { mapActions } from "vuex";
export default {
  props: ["orderId", "pid"],
  data() {
    return {
      canPay: true
    };
  },
  methods: {
    close() {
      this.$emit("closePayTips");
    },
    pay() {
      if (this.canPay) {
        this.canPay = false;

        fbSdkPay(this.orderId).then(
          res => {
            this.$store.commit("updateCommonTips", {
              msg: "儲值成功",
              style: POPUP_STYLE.good
            });
            this.canPay = true;
            this.close();
          },
          res => {
            var errmsg =
              "儲值失敗" +
              (!!res
                ? res["error_code"] == 1383010
                  ? "您取消了本次交易！"
                  : "原因：" + res["error_message"]
                : "");
            this.$store.commit("updateCommonTips", {
              msg: errmsg,
              style: POPUP_STYLE.bad
            });
            this.canPay = true;
            this.close();
          }
        );
        this.gaStatistics({
          eventName: "exc_store_pay",
          data: {
            pid: this.pid,
            pay_type: "facebook_local_money"
          }
        });
      }
    },
    ...mapActions(["gaStatistics"])
  },
  name: "FBPayTips"
};
</script>

<style lang="scss">
$imgURL: "../assets/img/";
$yellowColor: #f87e19;
$divide: 10 !default;
$pswWidth: 750;
.tipsContianer {
  position: absolute;
  z-index: 100;
  left: 50%;
  top: 50%;
  width: 477px;
  height: 252px;
  background: white;
  margin-left: (-477px/2);
  margin-top: (-252px/2);
  border: 2px solid $yellowColor;
  border-radius: 8px;
}
.closeTipsBtn {
  position: absolute;
  right: -25px;
  top: -25px;
  width: 57px;
  height: 57px;
  display: block;
  cursor: pointer;
  background: url($imgURL+"x.png");
  background-size: 100% 100%;
}
.tips-content {
  width: 100%;
  margin-top: 43px;
  font-size: 28px;
  text-align: center;
  color: #666;
}
.tips-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 82px;
  background: #8e8e8e;
  border-radius: 0 0 6px 6px;
}
.skipPayBtn {
  width: 177px;
  height: 56px;
  border-radius: 8px;
  color: white;
  font-size: 20px;
  line-height: 56px;
  text-align: center;
  display: block;
  background: $yellowColor;
  margin: (82px-56px)/2 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/FBPayTips.vue